import SafeHtml from "../../../Common/UI/SafeHtml";

type Props = {
  currentBlock: any;
};

const TextField = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;

  return (
    <div className="tiptap-text">
      <SafeHtml html={label} />
    </div>
  );
};
export default TextField;
